module.exports = __webpack_public_path__ + "a6aa1fedd807a9371ca0dbe9f71fc990.svg";